import { Button } from "@dippi/ui";
import { Box, styled } from "@mui/material";

export const Styled = {
    Container: styled(Box)`
        width: 550px;
        margin: auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        flex: 1;
    `,
    Header: styled(Box)`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    `,
    List: styled("ul")`
        width: 100%;
        max-height: 50vh;
        overflow-y: auto;
        margin-top: 10px;
        -ms-overflow-style: none;
        scrollbar-width: none;
        ::-webkit-scrollbar {
            display: none;
        }
    `,
    ListItem: styled("li")`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        padding: 20px;
        margin: 10px 0px;
        border-radius: 8px;
        background-color: ${props => props.theme.palette.secondary.main};
        &:hover {
            background-color: ${props => props.theme.palette.primary.main};
        }
    `,
    ClearBtn: styled(Button)`
        position: absolute;
        right: -30px;
        top: 50%;
        transform: translateY(-50%);
        padding: unset;
        min-width: unset;
    `,
};
